import styled from 'styled-components';
import LoadingSpinner from 'components/ui/LoadingSpinner';
import { ADMIN_ACCENT_PRIMARY } from 'style/constants';

export default styled(LoadingSpinner)`
  & *{
    color: ${ADMIN_ACCENT_PRIMARY};
  }
`;
